export default "__VITE_ASSET__D0wC_WxC__"